export default "__VITE_ASSET__nZFzDPOZ__"